import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row } from 'react-bootstrap';
import { EditorControls } from '../../../containers/basicEditor/editorControls';
import Background from '../../blanks/common/Background';
import corner3 from '../../../assets/img/icons/spot-illustrations/corner-3.png';

function PersonalForm({ user, setUser }) {
  return (
    <Card className="h-100">
      <Background image={corner3} className="rounded-soft bg-card" />
      <Card.Body className="z-index-1">
        <Row className="g-2 h-100 justify-content-between">
          <Col sm={6} md={6} key="Auth-Col-cName">
            <EditorControls.StringInput
              required
              controlId="form_cName"
              label="Ім\'я"
              value={user.changeDataByForm.firstName}
              onChange={(e, v) => setUser({
                ...user,
                changeDataByForm: {
                  ...user.changeDataByForm,
                  firstName: v,
                },
              })}
            />
          </Col>
          <Col sm={6} md={6} key="Auth-Col-cSecondName">
            <EditorControls.StringInput
              required
              controlId="form_cSecondName"
              label="Прізвище"
              value={user.changeDataByForm.lastName}
              onChange={(e, v) => setUser({
                ...user,
                changeDataByForm: {
                  ...user.changeDataByForm,
                  lastName: v,
                },
              })}
            />
          </Col>
        </Row>
        <Row className="g-2 h-100 justify-content-between">
          <Col sm={6} md={6} key="Auth-Col-login">
            <EditorControls.StringInput
              required
              controlId="form_login"
              label="Логін"
              value={user.changeDataByForm.login}
              onChange={(e, v) => setUser({
                ...user,
                changeDataByForm: {
                  ...user.changeDataByForm,
                  login: v,
                },
              })}
            />
          </Col>
          <Col sm={6} md={6} key="Auth-Col-kvk">
            <EditorControls.StringInput
              required
              controlId="form_kvk"
              label="Код відомчої класифікації (КВК)"
              value={user.changeDataByForm.kvk}
              onChange={(e, v) => setUser({
                ...user,
                changeDataByForm: {
                  ...user.changeDataByForm,
                  kvk: v,
                },
              })}
            />
          </Col>
        </Row>
        <Row className="g-2 h-100 justify-content-between">
          <Col sm={6} md={6} key="Auth-Col-City">
            <EditorControls.StringInput
              required
              controlId="form_phone"
              label="Телефон"
              value={user.changeDataByForm.phone}
              onChange={(e, v) => setUser({
                ...user,
                changeDataByForm: {
                  ...user.changeDataByForm,
                  phone: v,
                },
              })}
            />
          </Col>

          <Col sm={6} md={6} key="Auth-Col-City">
            <EditorControls.StringInput
              required
              controlId="form_cMail"
              label="Електронна пошта"
              value={user.changeDataByForm.EMail}
              onChange={(e, v) => setUser({
                ...user,
                changeDataByForm: {
                  ...user.changeDataByForm,
                  EMail: v,
                },
              })}
            />

          </Col>
        </Row>
        <Row className="g-2 h-100 justify-content-between">
          <Col sm={6} md={6} key="Auth-Col-City">
            <EditorControls.StringInput
              required
              controlId="form_netCode"
              label="ЄДРПОУ"
              value={user.changeDataByForm.Edrpou}
              onChange={(e, v) => setUser({
                ...user,
                changeDataByForm: {
                  ...user.changeDataByForm,
                  Edrpou: v,
                },
              })}
            />
          </Col>
          <Col sm={6} md={6} key="Auth-Col-City">
            <EditorControls.StringInput
              required
              controlId="form_netCode"
              label="Код за мережею"
              value={user.changeDataByForm.netCode}
              onChange={(e, v) => setUser({
                ...user,
                changeDataByForm: {
                  ...user.changeDataByForm,
                  netCode: v,
                },
              })}
            />
          </Col>
        </Row>
        <EditorControls.StringInput
          required
          controlId="form_inspectionCode"
          label="Код бюджету"
          value={user.changeDataByForm.inspectionCode}
          onChange={(e, v) => setUser({
            ...user,
            changeDataByForm: {
              ...user.changeDataByForm,
              inspectionCode: v,
            },
          })}
        />
      </Card.Body>
    </Card>
  );
}

PersonalForm.propTypes = {
  user: PropTypes.shape({
    avater: PropTypes.arrayOf([]),
    phone: PropTypes.string,
    EMail: PropTypes.string,
    userName: PropTypes.string,
    kvk: PropTypes.string,
    changeDataByForm: {
      phone: PropTypes.string,
      EMail: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      surName: PropTypes.string,
      kvk: PropTypes.string,
    },
  }).isRequired,
  setUser: PropTypes.func.isRequired,
};

export default PersonalForm;
